/*======================================================================================================================
  * Bluebell: src/app/state/postpro-settings/postpro-settings.effects.ts
  * Last Edited: 23/05/2025
  * Copyright 2025 Bramble CFD LTD
  * The contents of this file are NOT for redistribution
  * See AUTHORS for list of developers on this project
 =====================================================================================================================*/
import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EffectHandlerService } from '@services/effect-handler.service';
import { ApiService } from '@state/api.service';
import {
  loadPostproSettings,
  loadPostproSettingsFailure,
  loadPostproSettingsSuccess,
  savePostproSettings,
  savePostproSettingsSuccess,
  savePostproSettingsFailure,
} from '@state/postpro-settings/postpro-settings.actions';
import { PostproSettings } from '@state/postpro-settings/postpro-settings.interfaces';
import { switchMap } from 'rxjs';


@Injectable()
export class PostproSettingsEffects {
  private actions$ = inject(Actions);
  private api = inject(ApiService);
  private handler = inject(EffectHandlerService);


  load$ = createEffect(() => this.actions$.pipe(
    ofType(loadPostproSettings),
    switchMap(() => this.api.retrievePostproSettings().pipe(
      this.handler.effectResponse({
        success: (loadedSettings: PostproSettings) => loadPostproSettingsSuccess(loadedSettings),
        retry: loadPostproSettings(),
        failure: loadPostproSettingsFailure(),
        failureMessage: 'Error Loading Postpro Settings'
      }),
    ))
  ));

  update$ = createEffect(() => this.actions$.pipe(
    ofType(savePostproSettings),
    switchMap(({ settings }) => this.api.updatePostproSettings(settings).pipe(
      this.handler.effectResponse({
        success: (loadedSettings: PostproSettings) => savePostproSettingsSuccess(loadedSettings),
        retry: savePostproSettings(settings),
        failure: savePostproSettingsFailure(),
        successMessage: 'Successfully Saved Postpro Settings',
        failureMessage: 'Error Saving Postpro Settings'
      })
    ))
  ));
}
